var React = require('react');

function Quote (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20.5714 53.0417H36V28.6181H32L36 0.013916H26.8571L20.5714 28.6181V53.0417ZM0 53.0417H15.4286V28.6181H11.4286L15.4286 0.013916H6.28571L0 28.6181V53.0417Z"}));
}

Quote.defaultProps = {"width":"36","height":"54","viewBox":"0 0 36 54"};

module.exports = Quote;

Quote.default = Quote;
